import React, { useEffect, useState, useMemo } from 'react';
import {
  Button,
  Modal,
  Input,
  CheckBox,
  Select,
  InputTextArea,
  LoaderOn,
  openNotification,
  ANTD_COMPONENTS,
} from 'tt-ui-lib/core';
import {
  VideoIcon,
  AudioIcon,
  CloseCrossIcon,
  FileAddIcon,
  FileIcon,
  ImageIcon,
  LinkIcon,
  NetworkIcon,
  ReloadIcon,
  RightIcon,
  LogoIcon,
} from 'tt-ui-lib/icons';
import Cookies from 'js-cookie';
import { AvatarCropModal } from '../../../modules/tt-modals';
import { useMutation } from '@apollo/client';
import { DELETE_FROM_PUBLIC } from 'api';
import { ContentEditor } from '../../ContentEditor/Editor';
import styles from './NewPostModal.module.scss';
import { FilePreview } from './Components/Previews/FilePreview';
import {
  audioFileTypes,
  docFileTypes,
  imageFileTypes,
  videoFileTypes,
  allAlowedFileTypes,
  maxArticleTitleLength,
  maxArticlePreviewLength,
  maxPostBodyLength,
} from 'constants/addPost';
import { v1 as uuidv1 } from 'uuid';
import axios from 'axios';
import {
  addPost,
  fetchPostLinkPreview,
  getPostFileUploadLink,
} from '../../../api/posts/endpoints/posts';
import LinkPreview from './Components/Previews/LinkPreview';
import { setErrorMessage } from '../../../utils/appUtils';
import { generateUidForFile, isAudioFileOverlength } from '../../../utils/uploadUtils';

const { Avatar } = ANTD_COMPONENTS;

const selectVisionData = [
  {
    value: 'Anyone including search engines',
    id: 1,
    icon: <NetworkIcon style={{ width: 24, height: 24 }} />,
  },
  {
    value: 'Only TransparenTerra members',
    id: 2,
    icon: (
      <span style={{ height: 24 }}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M11.1557 5.01787C10.7857 4.93387 10.3997 4.88787 10.0017 4.88787C9.01572 4.88787 8.09772 5.16787 7.31172 5.65187L6.11572 5.05187C6.93172 4.41187 7.89572 3.98187 8.91572 3.80187C9.01172 3.78187 9.11172 3.77187 9.21172 3.75787L9.99972 0.983887L10.7937 3.75987L11.1557 5.01787Z"
            fill="#2E58A6"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M7.0358 5.83782C6.1058 6.50382 5.4058 7.47382 5.0858 8.59782L3.7998 8.96382C3.9698 7.95382 4.3798 6.99982 5.0038 6.18382C5.0698 6.10382 5.1338 6.02382 5.1998 5.94982L4.5038 4.56982L5.8798 5.25982L7.0358 5.83782Z"
            fill="#122164"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M5.65985 12.688V12.694L5.05585 13.89C4.41585 13.074 3.98585 12.114 3.80585 11.09C3.78985 10.994 3.77585 10.9 3.75985 10.8L0.98584 10.004L3.75985 9.214L5.01985 8.854C4.93585 9.224 4.88985 9.604 4.88985 9.998C4.88985 10.988 5.16985 11.908 5.65985 12.688Z"
            fill="#12491D"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M8.95996 16.2081C7.94996 16.0381 6.99596 15.6241 6.17996 14.9981C6.09996 14.9381 6.01996 14.8741 5.94396 14.8081L4.56396 15.4981L5.25396 14.1221L5.83396 12.9561C6.49396 13.8901 7.46396 14.5921 8.59396 14.9121L8.95996 16.2081Z"
            fill="#237D26"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M13.8857 14.9481C13.0697 15.5881 12.1117 16.0181 11.0857 16.1981C10.9897 16.2181 10.8957 16.2281 10.7957 16.2421L9.99975 19.0181L9.20375 16.2441L8.84375 14.9801C9.21375 15.0701 9.60375 15.1141 9.99775 15.1141C10.9878 15.1141 11.9077 14.8341 12.6877 14.3501L13.8857 14.9481Z"
            fill="#2DA131"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M14.8059 14.0638L15.4959 15.4438L14.1199 14.7538L12.9539 14.1738C13.8839 13.5138 14.5839 12.5438 14.9079 11.4198L16.2039 11.0498C16.0339 12.0598 15.6199 13.0158 14.9939 13.8298C14.9359 13.9078 14.8699 13.9878 14.8059 14.0638Z"
            fill="#41AA54"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M19.0159 10.0077L16.2399 10.7977L14.9739 11.1637C15.0639 10.7877 15.1099 10.3977 15.1099 9.99768C15.1099 9.01368 14.8299 8.09368 14.3459 7.31368L14.9459 6.11768C15.5919 6.93368 16.0219 7.89768 16.1959 8.91768C16.2159 9.01768 16.2319 9.11168 16.2419 9.21168L19.0159 10.0077Z"
            fill="#01A0C6"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            d="M15.4398 4.51811L14.7498 5.89411L14.1698 7.04811C13.5098 6.10811 12.5338 5.40811 11.4058 5.08411L11.0398 3.80811C12.0558 3.97411 13.0098 4.38811 13.8258 5.01411C13.9058 5.07811 13.9858 5.13811 14.0618 5.20811L15.4398 4.51811Z"
            fill="#4FA0CA"
          />
          {/* eslint-disable-next-line prettier/prettier */}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 10.006L16.504 9.006C16.322 7.81 15.82 6.72 15.084 5.828L16.048 3.91L14.12 4.876C13.242 4.166 12.174 3.678 11.008 3.498L10.004 0L9.004 3.498C7.804 3.68 6.712 4.186 5.82 4.924L3.904 3.96L4.868 5.888C4.158 6.768 3.672 7.838 3.496 9.008L0 10.006L3.498 11.004C3.68 12.2 4.186 13.29 4.924 14.182L3.956 16.106L5.896 15.138C6.774 15.846 7.838 16.328 9.002 16.506L10.002 20L11.006 16.506C12.198 16.324 13.288 15.818 14.178 15.084L16.106 16.052L15.134 14.118C15.842 13.24 16.326 12.172 16.506 11.008L20 10.006ZM14.54 5.27L14.56 5.26L14.834 5.12L14.7 5.4L14.69 5.42L14.51 5.77L14.024 6.74C13.424 5.996 12.62 5.424 11.694 5.104L11.424 4.16C12.24 4.36 13 4.726 13.664 5.23V5.236C13.738 5.292 13.814 5.352 13.89 5.416L14.024 5.53L14.54 5.27ZM9.24 4.026L9.416 4.006L9.576 3.462L9.584 3.44L10.006 1.968L10.424 3.44L10.432 3.462L10.542 3.832V3.838L10.836 4.892C10.566 4.848 10.286 4.822 10.002 4.822C9.102 4.822 8.256 5.052 7.516 5.456L6.63 5.012C7.336 4.536 8.126 4.216 8.96 4.066C9.054 4.05 9.144 4.036 9.24 4.026ZM5.114 5.176L5.386 5.316L5.408 5.326L6.728 5.986C5.988 6.586 5.418 7.39 5.104 8.31L4.154 8.586C4.354 7.776 4.714 7.016 5.224 6.35C5.284 6.276 5.344 6.196 5.404 6.124L5.524 5.99L5.264 5.47L5.254 5.45L5.114 5.176ZM3.46 10.434L3.438 10.426L1.97 10.004L3.434 9.586L3.458 9.578L4.884 9.168C4.844 9.438 4.818 9.718 4.818 9.998C4.818 10.898 5.048 11.748 5.452 12.488L5.012 13.372C4.536 12.672 4.218 11.878 4.072 11.042C4.052 10.952 4.042 10.858 4.028 10.762L4.008 10.586L3.46 10.434ZM5.474 14.74L5.452 14.75L5.17 14.896L5.312 14.614L5.324 14.592L5.494 14.248L5.984 13.278C6.588 14.014 7.388 14.582 8.304 14.898L8.578 15.858C7.768 15.658 7.008 15.298 6.344 14.788L6.34 14.78C6.27 14.73 6.194 14.67 6.12 14.604L5.986 14.484L5.474 14.74ZM5.434 10C5.434 7.48 7.478 5.434 10 5.434C12.524 5.434 14.57 7.478 14.57 10C14.57 12.526 12.526 14.57 10 14.57C7.48 14.57 5.434 12.526 5.434 10ZM10.76 15.976L10.584 15.996L10.43 16.54L10.422 16.564L10 18.036L9.582 16.566L9.574 16.542L9.164 15.112C9.438 15.156 9.714 15.182 10 15.182C10.904 15.182 11.75 14.952 12.484 14.546L13.368 14.992C12.668 15.466 11.874 15.786 11.038 15.936C10.95 15.95 10.854 15.96 10.76 15.976ZM14.89 14.84L14.608 14.696L14.586 14.686L14.246 14.516L13.26 14.026C14 13.426 14.576 12.626 14.89 11.706L15.85 11.432C15.654 12.24 15.29 13 14.78 13.66C14.724 13.74 14.66 13.814 14.6 13.89L14.486 14.026L14.74 14.53L14.75 14.55L14.89 14.84ZM15.11 10.846C15.154 10.572 15.18 10.286 15.18 10C15.18 9.1 14.95 8.256 14.55 7.52L14.99 6.64C15.466 7.34 15.784 8.136 15.93 8.97V8.976C15.95 9.066 15.96 9.156 15.974 9.25L15.994 9.426L16.544 9.586L16.566 9.59L18.034 10.01L16.564 10.43L16.544 10.434L15.11 10.846Z"
            fill="white"
          />
        </svg>
      </span>
    ),
  },
  // {
  //   value: 'Only for my community',
  //   id: 3,
  //   icon: <CommunityIcon style={{ width: 24, height: 24 }} />,
  // },
  { value: 'By link only', id: 4, icon: <LinkIcon style={{ width: 24, height: 24 }} /> },
];

export const NewPostModal = ({ visible = false, onClose, createType, receiverId, user }) => {
  const allowedFileDropTypes = useMemo(() => allAlowedFileTypes.split(', '), [allAlowedFileTypes]);
  const userID = typeof window !== 'undefined' ? Cookies.get('userId') : null;

  const [wordCount, setWordCount] = useState(0);
  const [postStringData, setPostStringData] = useState('');
  const [articleTitle, setArticleTitle] = useState('');
  const [articlePreviewText, setArticlePreviewText] = useState('');
  const [articleCover, setArticleCover] = useState(null);
  const [articleCoverFile, setArticleCoverFile] = useState(null);
  const [articleCoverLoading, setArticleCoverLoading] = useState(false);
  const [articleCoverError, setArticleCoverError] = useState(false);
  const [articleStep, setArticleStep] = useState(1);
  const [linkPreview, setLinkPreview] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isNewFilesAdded, setIsNewFilesAdded] = useState(false);

  const [allFiles, setAllFiles] = useState([]);
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  const [disableImage, setDisableImage] = useState(false);
  const [disableVideo, setDisableVideo] = useState(false);
  const [disableAudio, setDisableAudio] = useState(false);
  const [disableDoc, setDisableDoc] = useState(false);

  const [allowComments, setAllowComments] = useState(true);
  const [selectVision, setSelectVision] = useState(1);
  const [selectUser, setSelectUser] = useState();
  const [isCropImageModal, setIsCropImageModal] = useState(false);
  const [avatarFile, setAvatarFile] = useState(null);
  const [deletePublic] = useMutation(DELETE_FROM_PUBLIC);

  const submitDisable = useMemo(
    () => articleCoverLoading || !!allFiles.find((file) => file.loading === true),
    [articleCoverLoading, allFiles]
  );

  const updateFileInList = (newItem, id) => {
    setAllFiles((prevState) => {
      const items = [...prevState];
      const newItems = items.map((item) => {
        if (item.id === id) {
          return newItem;
        }
        return item;
      });

      return newItems;
    });
  };

  const uploadFile = async (item) => {
    updateFileInList({ ...item, loading: true, error: false }, item.id);

    const type = item.file.type.split('/')[0];
    const fileExt = item.file.name.match(/\.([^.]+)$/)[1];
    const fileName = `${uuidv1()}.${fileExt}`;
    let path = '';
    let fileType = '';

    switch (type) {
      case 'image':
        path = `${userID}/post/image_file`;
        fileType = 'image';
        break;
      case 'video':
        path = `${userID}/post/video_file`;
        fileType = 'video';
        break;
      case 'audio':
        path = `${userID}/post/audio_file`;
        fileType = 'audio';
        break;

      default:
        path = `${userID}/post/doc_file`;
        fileType = 'doc';
        break;
    }

    if (fileType === 'audio' && !!(await isAudioFileOverlength(item.file))) {
      openNotification({
        type: 'info',
        message: 'Audio files longer that 1 hour are not allowed.',
      });
      return;
    }

    const toUpload = { path: path, name: fileName };

    getPostFileUploadLink(toUpload)
      .then((response) => {
        const urlToUpload = response.data?.url;

        if (urlToUpload) {
          axios
            .put(urlToUpload, item.file, {
              headers: {
                'Content-type': item.file.type,
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((uploadResponse) => {
              if (uploadResponse.statusText === 'OK') {
                const updatedFile = {
                  ...item,
                  uuid: fileName,
                  url: `${'https://'}${response.data?.download_url}`,
                  loading: false,
                  fileType: fileType,
                };

                updateFileInList(updatedFile, item.id);
              }
            })
            .catch(() => {
              setErrorMessage('Error while uploading file');
              updateFileInList(
                { ...item, fileType: fileType, loading: false, error: true },
                item.id
              );
            });
        } else {
          setErrorMessage('Error while uploading file');
          updateFileInList({ ...item, fileType: fileType, loading: false, error: true }, item.id);
        }
      })
      .catch(() => {
        setErrorMessage('Error while uploading file');
        updateFileInList({ ...item, fileType: fileType, loading: false, error: true }, item.id);
      });
  };

  const uploadNewFiles = () => {
    allFiles.forEach((item) => {
      if (!item.loading && !item.url) {
        uploadFile(item);
      }
    });
  };

  useEffect(() => {
    if (isNewFilesAdded) {
      uploadNewFiles();
      setIsNewFilesAdded(false);
    }
  }, [isNewFilesAdded]);

  useEffect(() => {
    if (allFiles.length > 0) {
      setDisableVideo(true);
    }

    if (allFiles.length === 0) {
      setDisableVideo(false);
      setDisableDoc(false);
      setDisableImage(false);
      setDisableAudio(false);
    }

    if (allFiles.length < 5 && !allFiles.some((fileSort) => fileSort.file.type.includes('video'))) {
      setDisableDoc(false);
      setDisableImage(false);
      setDisableAudio(false);
    }
  }, [allFiles.length]);

  useEffect(() => {
    if (user) {
      setSelectUser(user.id);
    }
  }, [user]);

  const onChangeVisionSelect = (value) => {
    setSelectVision(value);
  };

  const onChangeUserSelect = (value) => {
    setSelectUser(value);
  };

  const safeStripHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };

  const closeModal = () => {
    setPostStringData('');
    setAllFiles([]);
    setDisableVideo(false);
    setDisableAudio(false);
    setDisableDoc(false);
    setDisableImage(false);
    setArticleTitle('');
    setArticlePreviewText('');
    setArticleCover(null);
    setArticleCoverError(false);
    setArticleCoverFile(null);
    setArticleStep(1);
    setLinkPreview(null);
    onClose();
  };

  const checked = () => {
    if (allowComments === false) {
      setAllowComments(true);
    } else {
      setAllowComments(false);
    }
  };

  const createPostInput = async () => {
    const linkPrev =
      linkPreview && createType !== 'article'
        ? JSON.stringify({
            url: linkPreview.link,
            image: linkPreview.image,
            title: linkPreview.title,
            description: linkPreview.description,
          })
        : undefined;

    const postData = {
      type: createType,
      body: postStringData,
      character_count: wordCount,
      title: createType === 'article' ? articleTitle : undefined,
      preview: createType === 'article' ? articlePreviewText : undefined,
      user_id: selectUser,
      link_preview: linkPrev,
      is_available_comments: allowComments,
      is_only_tt: selectVision === 2,
      is_only_community: selectVision === 3,
      is_link_only: selectVision === 4,
      files_image: [],
      files_video: [],
      files_audio: [],
      files_doc: [],
    };

    if (createType === 'article' && articleCover) {
      postData.files_image.push({
        uuid_name: articleCover.uuid,
        original_name: articleCover.file.name,
        is_preview: true,
      });
    }

    allFiles.forEach((value) => {
      const newPostFileData = { uuid_name: value.uuid, original_name: value.file.name };

      switch (value.fileType) {
        case 'image':
          postData.files_image.push(newPostFileData);
          break;
        case 'video':
          postData.files_video.push(newPostFileData);
          break;
        case 'audio':
          postData.files_audio.push(newPostFileData);
          break;

        default:
          postData.files_doc.push(newPostFileData);
          break;
      }
    });

    return postData;
  };

  const sendPost = async () => {
    setIsLoading(true);

    const postData = await createPostInput();
    const finalData = {
      ...postData,
    };

    addPost(finalData)
      .then((resp) => {
        if (resp.status === 200) {
          closeModal();
        }
      })
      .catch((err) => {
        openNotification({
          message: `Error while updating ${createType || 'post'}. Try again later.`,
          type: 'error',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const initials = user?.first_name
    ? `${user.first_name} ${user.last_name}`
        .split(' ')
        .map((i) => i[0])
        .join('')
    : '';

  const saveDataFromEditor = (editorData, editorDataWordCount = undefined) => {
    if (editorDataWordCount) setWordCount(editorDataWordCount);
    setPostStringData(editorData);
  };

  const handleFileSelect = (files, uploadType) => {
    const allowedTypes = ['image', 'audio', 'video', 'document'];
    const selectedFilesArray = [];

    for (let i = 0; i < files.length; i++) {
      const fileObj = files[i];
      const fileExt = fileObj.name.match(/\.([^.]+)$/)[1];
      const fileName = fileObj.name.split('.')[0];
      const file = new File(
        [fileObj],
        `${fileName}_file_${generateUidForFile(fileObj)}.${fileExt}`,
        { type: fileObj.type }
      );

      const fileType = uploadType || file.type.split('/')[0];

      if (selectedFilesArray.length === 5) {
        setErrorMessage('Only up to 5 files can be selected');
        break;
      }
      console.log(1, fileObj, file);
      if (!allowedFileDropTypes.includes(`.${fileExt}`)) {
        setErrorMessage('You can`t upload files of this type');
        break;
      }

      if (
        selectedFilesArray.some((fileSearch) => fileSearch.file.type.split('/')[0] === 'video') ||
        allFiles.some((fileSearch) => fileSearch.file.type.split('/')[0] === 'video')
      ) {
        setErrorMessage('Only one video can be uploaded');
        setDisableVideo(true);
        setDisableAudio(true);
        setDisableDoc(true);
        setDisableImage(true);
        break;
      }

      if (fileType === 'video') {
        if (
          selectedFilesArray.some((fileSearch) => fileSearch.file.type.split('/')[0] === 'video') ||
          allFiles.length > 0 ||
          selectedFilesArray.length > 0
        ) {
          setErrorMessage('Only one video can be uploaded');
          setDisableVideo(true);
          setDisableAudio(true);
          setDisableDoc(true);
          setDisableImage(true);
          break;
        } else {
          selectedFilesArray.push({
            file: file,
            videoName: file.name,
            thumbnail: '',
            url: '',
            uuid: '',
            loading: false,
            error: false,
            id: `${file.name}_${generateUidForFile(file)}`,
          });
          setDisableVideo(true);
          setDisableAudio(true);
          setDisableDoc(true);
          setDisableImage(true);
        }
      } else if (fileType === 'image') {
        selectedFilesArray.push({
          file: file,
          preview: URL.createObjectURL(file),
          url: '',
          uuid: '',
          loading: false,
          error: false,
          id: `${file.name}_${generateUidForFile(file)}`,
        });
      } else if (allowedTypes.includes(fileType)) {
        selectedFilesArray.push({
          file: file,
          url: '',
          uuid: '',
          loading: false,
          error: false,
          id: `${file.name}_${generateUidForFile(file)}`,
        });
      } else {
        setErrorMessage(`${fileType} files are not allowed`);
        setDisableVideo(true);
        setDisableAudio(true);
        setDisableDoc(true);
        setDisableImage(true);
        break;
      }

      const allLength = selectedFilesArray.length + allFiles.length;
      if (allLength <= 5) {
        setAllFiles([...allFiles, ...selectedFilesArray]);
        setIsNewFilesAdded(true);

        if (allLength === 5) {
          setDisableVideo(true);
          setDisableAudio(true);
          setDisableDoc(true);
          setDisableImage(true);
        }
      } else {
        setDisableVideo(true);
        setDisableAudio(true);
        setDisableDoc(true);
        setDisableImage(true);
        setErrorMessage('Only up to 5 files can be selected');
      }
    }
  };

  const handleRemoveFile = (fileId, uuid, url) => {
    const newSelectedFiles = allFiles.filter((item) => item.id !== fileId);
    setAllFiles(newSelectedFiles);

    const fileToDel = { path: url, name: uuid };
    deletePublic({ variables: { input: fileToDel } });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDraggingOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const dropFiles = event.dataTransfer.files;

    handleFileSelect(dropFiles);

    setIsDraggingOver(false);
  };

  const uploadArticleCover = (file) => {
    setArticleCoverFile(file);
    setArticleCoverError(false);
    setArticleCoverLoading(true);

    const fileName = `${uuidv1()}.png`;
    const fileType = 'image';
    const path = `${userID}/post/image_file`;

    const toUpload = { path: path, name: fileName };

    getPostFileUploadLink(toUpload)
      .then((response) => {
        const urlToUpload = response.data?.url;

        if (urlToUpload) {
          axios
            .put(urlToUpload, file, {
              headers: {
                'Content-type': file.type,
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((uploadResponse) => {
              if (uploadResponse.statusText === 'OK') {
                const updatedFile = {
                  file: file,
                  uuid: fileName,
                  url: `${'https://'}${response.data?.download_url}`,
                  loading: false,
                  fileType: fileType,
                  preview: URL.createObjectURL(file),
                };

                setArticleCover(updatedFile);
                setArticleCoverLoading(false);
                setArticleCoverFile(null);
              }
            })
            .catch(() => {
              setErrorMessage('Error while uploading file');
              setArticleCoverError(true);
              setArticleCoverLoading(false);
            });
        } else {
          setErrorMessage('Error while uploading file');
          setArticleCoverError(true);
          setArticleCoverLoading(false);
        }
      })
      .catch(() => {
        setErrorMessage('Error while uploading file');
        setArticleCoverError(true);
        setArticleCoverLoading(false);
      });
  };

  const handleDropArticleCover = (event) => {
    event.preventDefault();
    const dropFile = event.dataTransfer.files[0];

    uploadArticleCover(dropFile);

    setIsDraggingOver(false);
  };

  const isValidPost = () => postStringData.length > 0 || allFiles.length > 0;

  const isValidArticleStep = (step) => {
    let passed = true;

    if (step === 1) {
      passed = articleTitle.length > 0 && postStringData.length > 0;
    }

    if (step === 2) {
      passed = articlePreviewText.length > 0;
    }

    return passed;
  };

  useEffect(() => {
    if (linkPreview?.link) {
      if (!postStringData.includes(linkPreview?.link)) {
        setLinkPreview(null);
      }
    }
  }, [postStringData, linkPreview]);

  const getPreviewFromLink = async (link) => {
    setLinkPreview({
      link: link,
      loading: true,
      image: '',
      title: '',
      description: '',
    });

    fetchPostLinkPreview(link)
      .then((response) => {
        if (response.status === 200) {
          const { data } = response.data;

          const result = {
            title: data.ogTitle || data.twitterTitle || '',
            description: data.ogDescription || data.twitterDescription || '',
            image: data.ogImage || data.twitterImage || '',
          };

          setLinkPreview({
            link: link,
            loading: false,
            image: result.image,
            title: result.title,
            description: result.description,
          });
        }
      })
      .catch(() => {
        setLinkPreview({
          link: link,
          loading: false,
          image: '',
          title: '',
          description: '',
        });
      });
  };
  const handleUpdateAvatar = (file) => {
    uploadArticleCover(file);
  };

  const openCropModal = (file) => {
    if (file) {
      const fileSize = (file.size / 1024 / 1024).toFixed(2);
      if (fileSize <= 5) {
        setAvatarFile(file);
        setIsCropImageModal(true);
      } else {
        openNotification({
          message: 'Allowed files with 5MB or below.',
          type: 'info',
        });
      }
    }
  };

  return (
    <Modal
      open={visible}
      onClose={closeModal}
      title={`Create ${createType}`}
      onClick={(event) => event.stopPropagation()}
      fullScreenOnResponse
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      closeOnlyByControls
    >
      <div className={styles.modal_body} id="modalBody">
        <div className={styles.modal_option}>
          <div className={styles.inputOptions}>
            <Select
              label="Select user"
              value={selectUser}
              onChange={onChangeUserSelect}
              options={[
                {
                  value: user?.id || '',
                  label: (
                    <div className={styles.selectItem}>
                      <Avatar src={user?.avatar} className={styles.avatar}>
                        {user?.first_name
                          ? `${user.first_name} ${user.last_name}`
                              .split(' ')
                              .map((i) => i[0])
                              .join('')
                          : ''}
                      </Avatar>
                      <span>
                        {user.first_name} {user.last_name}
                      </span>
                    </div>
                  ),
                },
              ]}
            />

            <Select
              label="Suggest a role"
              value={selectVision}
              onChange={onChangeVisionSelect}
              options={selectVisionData.map((element) => ({
                value: element.id,
                label: (
                  <div className={styles.selectItem}>
                    {element.icon}
                    <span>{element.value}</span>
                  </div>
                ),
              }))}
            />
          </div>
        </div>

        {createType === 'article' ? (
          <>
            {articleStep === 1 ? (
              <div>
                <Input
                  placeholder="Headline"
                  className={styles.articleInput}
                  value={articleTitle}
                  onChange={(e) => setArticleTitle(e.target.value)}
                />

                <div
                  className={styles.dndArticleCover}
                  style={{
                    border: articleCoverError ? '1px solid red' : 'none',
                    height: articleCoverError || articleCover ? 'fit-content' : '200px',
                  }}
                  onDrop={handleDropArticleCover}
                >
                  <input
                    id="article-cover-upload"
                    type="file"
                    hidden
                    onChange={(e) => {
                      openCropModal(e.target.files[0]);
                    }}
                    accept={imageFileTypes}
                  />
                  {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                  <label
                    htmlFor="article-cover-upload"
                    style={{ width: '100%', height: '100%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={styles.dndCoverContent}>
                      {articleCover ? (
                        <>
                          <img
                            src={articleCover.preview}
                            alt=""
                            style={{
                              borderRadius: 12,
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                            }}
                          />
                          <button
                            type="button"
                            className={styles.uploadImgClose}
                            style={{
                              display: 'flex',
                              zIndex: 2000,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setArticleCover(null);
                              setArticleCoverError(false);
                              setArticleCoverFile(null);
                            }}
                          >
                            <CloseCrossIcon
                              style={{ width: 16, height: 16 }}
                              className="icon-white-fill"
                            />
                          </button>
                        </>
                      ) : articleCoverLoading ? (
                        <LoaderOn />
                      ) : articleCoverError ? (
                        <>
                          <img
                            src={articleCoverFile ? URL.createObjectURL(articleCoverFile) : ''}
                            alt=""
                            style={{
                              borderRadius: 12,
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                            }}
                            className="blur-content"
                          />
                          <Button
                            type="icon"
                            style={{ position: 'absolute' }}
                            onClick={() => {
                              uploadArticleCover(articleCoverFile);
                            }}
                          >
                            <ReloadIcon
                              style={{
                                width: 20,
                                height: 20,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            />
                          </Button>
                          <button
                            type="button"
                            className={styles.uploadImgClose}
                            style={{
                              display: 'flex',
                              zIndex: 2000,
                            }}
                            onClick={() => {
                              setArticleCover(null);
                              setArticleCoverError(false);
                              setArticleCoverFile(null);
                            }}
                          >
                            <CloseCrossIcon
                              style={{ width: 16, height: 16 }}
                              className="icon-white-fill"
                            />
                          </button>
                        </>
                      ) : (
                        <>
                          <div className={styles.dndCoverContentHeader}>
                            <ImageIcon className={styles.dndIcon} />
                            <span>No cover image uploaded</span>
                          </div>
                          <div className={styles.dndCoverContentDesc}>
                            Consider adding a cover image that complements your article to attract
                            more readers. We recommend uploading an image with a pixel size of 1280
                            x 720.
                          </div>
                        </>
                      )}
                    </div>
                  </label>
                </div>

                <ContentEditor
                  value={postStringData}
                  saveDataMethod={saveDataFromEditor}
                  placeholder="Share your story..."
                  className={styles.articleEditor}
                  imageUploadPath={`${userID}/post/image_file`}
                />
              </div>
            ) : (
              <div>
                <InputTextArea
                  placeholder="Tell your network what your article is about."
                  className={styles.articleTextArea}
                  value={articlePreviewText}
                  onChange={(e) => setArticlePreviewText(e.target.value)}
                />

                <div className={styles.articlePreviewBlock}>
                  {articleCover && articleCoverFile ? (
                    <div>
                      <img
                        src={URL.createObjectURL(articleCoverFile) || ''}
                        alt=""
                        className={styles.articleCover}
                      />
                    </div>
                  ) : null}

                  <div className={styles.articleLink}>
                    <div className={styles.articleLinkContent}>
                      <div className={styles.articleTitle}>{articleTitle}</div>
                    </div>

                    <div>
                      <RightIcon style={{ width: 20, height: 20 }} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className={styles.modal_textArea}>
            <div className={styles.dndCover} style={{ display: isDraggingOver ? 'flex' : 'none' }}>
              <div className={styles.dndCoverContent}>
                <div className={styles.dndCoverContentHeader}>
                  {/* <img src="/images/add-post/dnd.svg" alt="" /> */}
                  <FileAddIcon className={styles.dndIcon} />
                  <span>Drag files here</span>
                </div>
                <div className={styles.dndCoverContentDesc}>
                  One post cannot contain more than 5 attachments or more than 1 video.
                </div>
              </div>
            </div>

            <ContentEditor
              value={postStringData}
              saveDataMethod={saveDataFromEditor}
              placeholder="Share your story..."
              getPreviewFromLink={getPreviewFromLink}
              maxLength={maxPostBodyLength}
              disableControls
            />

            {linkPreview && !linkPreview.loading && (
              <LinkPreview
                url={linkPreview.link}
                title={linkPreview.title}
                description={linkPreview.description}
                imageUrl={linkPreview.image}
                onRemovePreview={() => setLinkPreview(null)}
                isEdit
              />
            )}
          </div>
        )}

        {/* Files preview */}
        <FilePreview
          selectedFiles={allFiles}
          handleRemoveFile={handleRemoveFile}
          handleFileUpload={uploadFile}
          updateFileMethod={updateFileInList}
        />

        <div>
          {createType === 'article' && articleStep === 2 ? null : (
            <CheckBox label="Turn off comments" value={!allowComments} onChange={() => checked()} />
          )}
        </div>

        <div className={styles.buttonField}>
          {createType === 'article' && articleStep === 2 ? (
            <Button
              type="default"
              className={styles.backButton}
              onClick={() => setArticleStep(1)}
              disabled={isLoading}
            >
              BACK
            </Button>
          ) : (
            <div className={styles.optionButton}>
              {/* image upload */}
              <Button type="icon" id="openImageModalButtons" disabled={disableImage}>
                <input
                  id="post-img-upload"
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => handleFileSelect(e.target.files, 'image')}
                  accept={imageFileTypes}
                />
                <label
                  htmlFor="post-img-upload"
                  className={disableImage ? styles.disabledUploadButton : ''}
                >
                  <ImageIcon style={{ width: 24, height: 24 }} />
                </label>
              </Button>

              {/* video upload */}
              <Button type="icon" id="openVideoModalButtons" disabled={disableVideo}>
                <input
                  id="post-video-upload"
                  type="file"
                  hidden
                  onChange={(e) => handleFileSelect(e.target.files, 'video')}
                  accept={videoFileTypes}
                />
                <label
                  htmlFor="post-video-upload"
                  className={disableVideo ? styles.disabledUploadButton : ''}
                >
                  <VideoIcon style={{ width: 24, height: 24 }} />
                </label>
              </Button>

              {/* audio upload */}
              <Button type="icon" id="openAudioModalButtons" disabled={disableAudio}>
                <input
                  id="post-audio-upload"
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => handleFileSelect(e.target.files, 'audio')}
                  accept={audioFileTypes}
                />
                <label
                  htmlFor="post-audio-upload"
                  className={disableAudio ? styles.disabledUploadButton : ''}
                >
                  <AudioIcon style={{ width: 24, height: 24 }} />
                </label>
              </Button>

              {/* doc upload */}
              <Button type="icon" id="openDocModalButtons" disabled={disableDoc}>
                <input
                  id="post-file-upload"
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => handleFileSelect(e.target.files, 'document')}
                  accept={docFileTypes}
                />
                <label
                  htmlFor="post-file-upload"
                  className={disableDoc ? styles.disabledUploadButton : ''}
                >
                  <FileIcon style={{ width: 24, height: 24 }} />
                </label>
              </Button>
            </div>
          )}

          <div>
            {createType === 'article' ? (
              <>
                {articleStep === 1 ? (
                  <Button
                    type="primary"
                    className={styles.submitButton}
                    onClick={() => {
                      if (isValidArticleStep(1)) {
                        setArticleStep(2);
                      } else {
                        openNotification({
                          type: 'info',
                          message: 'Please, fill article title and article body',
                        });
                      }
                    }}
                    disabled={submitDisable}
                    loading={isLoading}
                  >
                    NEXT
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    className={styles.submitButton}
                    onClick={() => {
                      if (isValidArticleStep(2)) {
                        sendPost();
                      } else {
                        openNotification({
                          type: 'info',
                          message: 'Please, fill article preview field',
                        });
                      }
                    }}
                    disabled={submitDisable}
                    loading={isLoading}
                  >
                    PUBLISH
                  </Button>
                )}
              </>
            ) : (
              <Button
                type="primary"
                className={styles.submitButton}
                onClick={() => {
                  if (isValidPost()) {
                    sendPost();
                  } else {
                    openNotification({
                      type: 'info',
                      message: 'Please, fill post body',
                    });
                  }
                }}
                disabled={
                  safeStripHtml(postStringData).length >= maxPostBodyLength || submitDisable
                }
                loading={isLoading}
              >
                PUBLISH
              </Button>
            )}
          </div>
        </div>
        {isCropImageModal && (
          <AvatarCropModal
            open={isCropImageModal}
            setOpen={setIsCropImageModal}
            avatarFile={avatarFile}
            setAvatar={handleUpdateAvatar}
            width={620}
            height={317}
            borderRadius={4}
          />
        )}
      </div>
    </Modal>
  );
};
